import React from 'react';
import { Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import ShowIcon from '@/assets/icons/show-icon.svg?react';
import { usePopoverContext } from '@/components/global/buttons/CustomMorePopover';

const CustomShowModalButton = ({ onOpen, label, icon }) => {
    const { closePopover } = usePopoverContext();
    const translate = useTranslate();
    const buttonLabel = label || translate('common.buttonLabels.show');

    return (
        <Button
            onClick={event => {
                event.stopPropagation();
                onOpen();
                closePopover();
            }}
            aria-label={buttonLabel}
        >
            {icon || <ShowIcon />} {buttonLabel}
        </Button>
    );
};

CustomShowModalButton.propTypes = {
    onOpen: PropTypes.func.isRequired,
    label: PropTypes.string,
    icon: PropTypes.node,
};

export default CustomShowModalButton;
